const message =
	"Hello, my name is [NAME]. I would like to book you on [DATE] at [TIME] for [LENGTH]. Please let me know if you're available. Thank you.";
export const smsLink = `SMS:+61493439302?body=${message}`;
export const emailLink = `mailto:hello@lulureynolds.com.au?subject=Booking Inquiry&body=${message}`;

interface Interests {
	label: string;
	additionalInfo?: string;
}

export const interests: Interests[] = [
	{
		label: "anime",
		additionalInfo:
			"Recently discovered Attack on Titan. Revisiting the nostalgic Dragon Ball.",
	},
	{
		label: "art",
		additionalInfo: "Who doesn't enjoy looking at pretty things.",
	},
	{
		label: "video games",
		additionalInfo:
			"I'm a life long gamer but I'm currently replaying Immortals Fenyx Rising.",
	},
	{
		label: "board games",
		additionalInfo:
			"I recently won a round of Lords of Waterdeep and have been exploring MicroMacro Crime City solo.",
	},
	{
		label: "film",
		additionalInfo:
			"I particularly enjoy watching movies with cool practical effects.",
	},
	{
		label: "gardening",
		additionalInfo:
			"Love pottering around in my yard. Growing some flowering plants for the birds and bees.",
	},
	{
		label: "history",
		additionalInfo:
			"Learning facts about the world is one of my favourite pleasures in life. I visit the museum in every city I travel to.",
	},
	{
		label: "photography",
		additionalInfo:
			"Whatever oddities peak my interest while I'm exploring, from cool buildings to things where they don't belong.",
	},
	{ label: "bouldering" },
	{
		label: "wine",
		additionalInfo:
			"I'm partial to Pinot Noir but I'm coming around to Chardonnay.",
	},
	{
		label: "music",
		additionalInfo: "I love listening to Soul, Jazz, Funk + R&B.",
	},
	{
		label: "reading",
		additionalInfo:
			"I basically only read non-fiction. I just want to learn facts about the world.",
	},
	{
		label: "cooking",
		additionalInfo:
			"I enjoy cooking so much that I hardly ever eat out. Asian food is my favourite, particularly Indonesian + Japanese.",
	},
	{
		label: "languages",
		additionalInfo:
			"I dabble in French + have recently begun to learn Japanese",
	},
];

interface FAQ {
	label: string;
	info: string[];
}

export const faqs: FAQ[] = [
	{
		label: "General",
		info: [
			"I generally prefer to see new clients for at least 2 hours so we can take our time getting to know each other although I understand if your schedule doesn't allow. I want to make sure you have all my attention and energy so you'll be my only arrangement for the day.",
		],
	},
	{
		label: "Services",
		info: [
			"I don’t have a set list of services so you can think of the experience like GFE with a little spice however let me know if there's something in particular you're after and I'll let you know if that's something I can do for you.",
			"If you have any special requests I'll take them into consideration although I'll let you know in advance if it's not something I can help you with. I want to provide you with an authentic experience with genuine pleasure so I only partake in activities I personally enjoy.",
		],
	},
	{
		label: "Discretion",
		info: [
			"If you’re unsure of what hotel to stay at where we can meet discreetly I would be happy to offer some suggestions. There are many options where we can meet away from prying eyes before heading up to the room. Feel free to let me know any concerns you may have and I’ll be happy to help resolve them as best I can.",
			"Any info I require prior to meeting will be treated with the utmost discretion. Please note, any requirements I have to secure a booking are not only to show respect for my time but also for my safety.",
		],
	},
	{
		label: "Contact",
		info: [
			"The best method of contact is either text or email. To help assist a smooth booking process, in your first message please include your name, preferred time, date, and duration. You're also welcome to include and questions or special requests you may have.",
			"Respect and good manners go a long way and will ensure a meeting with me. Impolite enquiries will be ignored and will cause you to miss out on any potential encounters in the future. Please note that I do not accept phone calls.",
			"I will do my best to respond as soon as possible. Usually you can expect a response within 24-48 hours or first thing Monday if it's a weekend.",
		],
	},
	{
		label: "Deposits",
		info: [
			"A deposit is required to secure our date. You can pay this by BeemIt or credit card. Let me know if you’d like to pay a different way and I’ll see what I can do.",
			"The deposit is not refundable if you cancel. In the unfortunate event of a cancellation, the deposit will be retained as compensation for my time. With enough notice, we may be able to reschedule to another date.",
		],
	},
	{
		label: "Cancellations / Rainchecks",
		info: [
			"If I must cancel due to unforeseen circumstances, the deposit will of course be returned to you. However if I cancel due to poor manners from you prior to meeting the deposit will be forfeit.",
			"If you need to postpone, I require at least 48 hours notice. If you think you’re getting sick a few days before then don’t be afraid to let me know ahead of time so we can reschedule. If I am hosting, in the unlikely case that I am unable to change the date for the accommodation then I will require an additional hosting fee.",
		],
	},
	{
		label: "On the day",
		info: [
			"If I’m meeting you at your hotel and the lift requires a room key to be swiped to gain access, I will text you when I arrive so you can meet me by the lifts. If no key is needed to get up to the room then just text me the room number when you check in and I will come up to you.",
			"If you haven’t already paid the total remuneration, bring the remaining in cash an envelope which you can hand to me upon entry or place on a table nearby.",
		],
	},
];

interface Testimonial {
	name?: string;
	testimonial: string[];
}

export const testimonials: Testimonial[] = [
	{
		name: "Z",
		testimonial: [
			"From the moment Lulu opened the door I was taken aback. She’s absolutely stunning — effortlessly sexy in a way that feels completely natural. But it was the way she carried herself that really caught my attention. She’s smart, confident, and has this cheeky smile that just pulls you in.",
			"It was my first time so I was definitely a bit nervous, but she made me feel comfortable straight away. The conversation flowed, we had a few laughs, and everything just felt easy. There was a natural connection that I wasn’t expecting.",
			"She has this calm, playful energy that stays with you long after you’ve left. I walked out feeling lighter, relaxed, and honestly just in a better headspace. It was fun, no doubt about that, but it also felt real.",
			"I seriously can’t wait to see her again.",
		],
	},
];
